import "./TextWrapper.css";

import { Typography } from "@saviynt/design-system";

export default function TextWrapper({
  label,
  subLabel,
}: {
  label: string;
  subLabel: string;
}) {
  return (
    <div className="Nhi-AccessMap-Node-Text-Wrapper">
      <div className="label">
        <Typography
          tooltipConfigs={{ placement: "top", isPortalEnabled: true }}
          kind="body1"
          lineLimit={1}
          desktop="body1-d"
          mobile="body1-d"
        >
          {label}
        </Typography>
      </div>
      <div className="label">
        <Typography
          tooltipConfigs={{ placement: "top", isPortalEnabled: true }}
          kind="body3"
          lineLimit={1}
          desktop="body3-d"
          mobile="body3-d"
        >
          {subLabel}
        </Typography>
      </div>
    </div>
  );
}
